/**
 * PublicLayout — §14.3 "(public)" layout.
 * Centered card on a gradient hero background.
 * Used for: login, forgot-password, reset-password.
 */

import { Outlet } from 'react-router-dom';

import CreatedByCredit from '@/components/layout/CreatedByCredit';

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/10 via-background to-secondary/5 flex items-center justify-center p-4">
      {/* Card wrapper — max-w-md keeps forms readable (§15.4) */}
      <div className="w-full max-w-md">
        {/* Platform wordmark */}
        <div className="text-center mb-8">
          <p className="text-sm text-muted-foreground font-medium tracking-wide uppercase">
            NIRC of ICAI
          </p>
          <h1 className="text-2xl font-bold text-foreground mt-1 tracking-tight">
            Office Process Automation
          </h1>
        </div>

        {/* Route content rendered here */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-8">
          <Outlet />
        </div>

        <p className="text-center text-xs text-muted-foreground mt-6">
          &copy; {new Date().getFullYear()} NIRC of ICAI. All rights reserved.
        </p>
        <CreatedByCredit className="mt-1" />
      </div>
    </div>
  );
}
